import { useRef } from 'react';

export function useLatestRef<T>(value: T): React.MutableRefObject<T> {
  const latestRef = useRef(value);
  latestRef.current = value;
  return latestRef;
}
